const Splash = () => {
    return (
        <div className="w-full h-screen flex flex-col justify-center items-center">
              <img className="w-56" src="../assets/icon/logo.svg" alt="logo" />
              {/* <img src="assets/icon/three-dots.svg" /> */}
        </div>
    )
}

export default Splash;